import api from './api';

// AI-suggested report review (backend: ReportReviewController).
// A doctor and a navigator each review a report independently; the server
// scopes the queue to the caller's own patients and drops a report from a
// reviewer's queue once that reviewer has submitted.
export const reportReviewAPI = {
  // GET /api/report-reviews/pending -> [PendingItem]
  pending: () => api.get('/report-reviews/pending'),

  // POST /api/report-reviews/{triageResultId}
  // Body: { outcome: 'AGREED' | 'ADJUSTED', note?, acceptedActionIds: [] }
  // ADJUSTED requires a note. Accepted actions become care-plan items.
  submit: (triageResultId, body) => api.post(`/report-reviews/${triageResultId}`, body),

  // GET /api/report-reviews/reviewed -> [ReviewedItem], this reviewer's own past
  // reviews, newest first: { reviewId, triageResultId, patientId, patientName,
  // drawDate, riskLevel, riskScore, outcome, note, acceptedActionCount, reviewedAt }
  reviewed: () => api.get('/report-reviews/reviewed'),

  // GET /api/report-reviews/status/{triageResultId} -> { navigator, doctor }, each
  // { role, reviewed, outcome, reviewerName, reviewedAt }: who has reviewed one report.
  status: (triageResultId) => api.get(`/report-reviews/status/${triageResultId}`),

  // GET /api/report-reviews/lifestyle (doctor only) -> { pending: [], reviewed: [] }
  // of AI lifestyle points ("recommendations"). Accepting or rejecting one goes
  // through doctorLifestyleItemAPI, the same call the patient record screen uses.
  // With any of page (0-based), size (default 25, max 100) or q (max 100 chars)
  // it returns one page, sorted by the server (report date, then created, then
  // patient), plus { pendingTotal, page, size }. A server without paging
  // ignores the params and has no pendingTotal.
  lifestyle: (params) => api.get('/report-reviews/lifestyle', { params }),
};
